// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"eef18510","58":"f9fc7d1d","117":"b580e7f9","139":"535b94e2","352":"f5e19fb5","453":"9a403da3","765":"c1b4e4af","905":"9d26196d","934":"84334c5c","954":"cd30cca8","989":"ef9f2441"}[chunkId] + ".chunk.js";
};